import { createStore } from 'vuex'
import Auth from './modules/auth'
import Notificat  from './modules/notification';

export default createStore({
  modules: {
    auth: Auth,
    notificat: Notificat
  }
})